import type { GetNearbyPoisLanguageCodeEnum } from '@linktivity/tata';
import { action, computed, observable } from 'mobx';
import i18n from '~/i18n';

export class LangStore {
  @observable accessor language = i18n.language;

  constructor() {
    // Keep `language` in sync with i18next, which is the source of truth.
    i18n.on('languageChanged', lang => this.setLanguage(lang));
  }

  @action
  setLanguage(language: string) {
    this.language = language;
  }

  @computed
  get languageCode(): GetNearbyPoisLanguageCodeEnum {
    return this.language.toUpperCase() as GetNearbyPoisLanguageCodeEnum;
  }
}

export default new LangStore();
